import { cloneDeep } from "lodash";

const SET_NOTIFICATION_CAMPAIGNS = "app/notificationCampaigns/SET_NOTIFICATION_CAMPAIGNS";
const SET_NOTIFICATION_CAMPAIGN_DETAILS =
  "app/notificationCampaigns/SET_NOTIFICATION_CAMPAIGN_DETAILS";
const SET_NOTIFICATION_CAMPAIGN_TO_EDIT =
  "app/notificationCampaigns/SET_NOTIFICATION_CAMPAIGN_TO_EDIT";
const SET_LOADING = "app/notificationCampaigns/SET_LOADING";
const SET_REFRESH = "app/notificationCampaigns/SET_REFRESH";
const SET_NOTIFICATION_CAMPAIGN_DETAILS_REFRESH =
  "app/notificationCampaigns/SET_NOTIFICATION_CAMPAIGN_DETAILS_REFRESH";
const SET_ERROR = "app/notificationCampaigns/SET_ERROR";

const initialState = {
  notificationCampaigns: [],
  notificationCampaignDetails: null,
  notificationCampaignToEdit: null,
  loading: false,
  error: null,
  refresh: false,
  notificationCampaignDetailsRefresh: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_NOTIFICATION_CAMPAIGNS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        notificationCampaigns: action.payload
      };
    }

    case SET_NOTIFICATION_CAMPAIGN_DETAILS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        notificationCampaignDetails: action.payload
      };
    }

    case SET_NOTIFICATION_CAMPAIGN_TO_EDIT: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        notificationCampaignToEdit: action.payload
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_NOTIFICATION_CAMPAIGN_DETAILS_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        notificationCampaignDetailsRefresh: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const setNotificationCampaigns = (notificationCampaigns) => ({
  type: SET_NOTIFICATION_CAMPAIGNS,
  payload: notificationCampaigns
});

export const setNotificationCampaignDetails = (notificationCampaignDetails) => ({
  type: SET_NOTIFICATION_CAMPAIGN_DETAILS,
  payload: notificationCampaignDetails
});

export const setNotificationCampaignToEdit = (notificationCampaign) => ({
  type: SET_NOTIFICATION_CAMPAIGN_TO_EDIT,
  payload: notificationCampaign
});

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setNotificationCampaignDetailsRefresh = (refresh) => ({
  type: SET_NOTIFICATION_CAMPAIGN_DETAILS_REFRESH,
  payload: refresh
});

export const setError = (error) => ({ type: SET_ERROR, payload: error });
